import React from 'react'
import {
  //BrowserRouter as Router,
  //Route,
  //Link,
  Redirect,
  //withRouter
} from 'react-router-dom'

export default () => {
  return (
    <div>
      <Redirect to={'/persons'}/>
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/welcome.js